<iframe class="shadow m-5" width="90%" height="1280" frameBorder="0" [src]="urlSafe"></iframe>

